import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['checkbox'];
  static values = { submitId: String };

  connect() {
    this.updateSubmitState();
  }

  // The submit button lives in the modal's footer, outside this controller's DOM
  // subtree, so it's addressed by id rather than a Stimulus target. Once a request
  // exists, the footer (and its button) is removed - there's nothing left to update.
  updateSubmitState() {
    const submit = document.getElementById(this.submitIdValue);
    if (!submit) return;

    submit.disabled = !this.checkboxTargets.some(
      (checkbox) => checkbox.checked,
    );
  }
}
